// extracted by mini-css-extract-plugin
module.exports = {"content":"SectionContent-module--content--19BFt","centered":"SectionContent-module--centered--X5YBM"};